/** Zed canvas painter stub. */
export class ZedPainter {
  static draw(ctx, entity, teamColor) {
    ctx.fillStyle = teamColor || '#64748b';
    ctx.beginPath();
    ctx.arc(entity.x, entity.y, entity.radius || 20, 0, Math.PI * 2);
    ctx.fill();
  }
}
